'use strict'

angular
  .module('surfsightApp.controllers')
  .controller('organizationRetentionSettingsEditController', [
    '$scope',
    '$mdDialog',
    '$rootScope',
    '$mdColors',
    'UnitSystem',
    '$filter',
    '$mdToast',
    '$localStorage',
    function (
      $scope,
      $mdDialog,
      $rootScope,
      $mdColors,
      UnitSystem,
      $filter,
      $mdToast,
      $localStorage
    ) {
      $scope.themePrimary = $mdColors.getThemeColor('primary')
      $scope.themeAccent = $mdColors.getThemeColor('accent')
      $scope.retentionConfig =
        $rootScope.organizationSettings.organizationRetentionSettings
      $scope.cancelRetentionSettings = () => {
        $mdDialog.cancel()
      }
      $scope.saveRetentionSettings = () => {
        $mdDialog.hide({ deviceRetentionMinutes: $scope.retentionConfig })
      }
      $scope.cancelRetentionSettings = () => {
        $mdDialog.cancel()
      }
      $scope.isRestrictedUser =
        $localStorage.userDetails.accessLevel === 'viewer'
    }
  ])
